import React, { useEffect, useState } from 'react'
import './Career_Inner.css'
import Career_Card from '../career/career_card/Career_Card'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Black_Btn from '../common_components/common_btn/black_btn/Black_Btn'
import Success_Modal from '../common_components/common_modal/success_modal/Success_Modal'
import { useNavigate, useParams } from 'react-router-dom'
import { decodeId, formatDate } from '../../utils/common'
import { useDispatch, useSelector } from 'react-redux'
import { addResume, getCareerById } from '../../features/career/careerSlice'
import parse from 'html-react-parser'
import { useForm } from 'react-hook-form'

const Career_Inner = () => {

    const { id } = useParams(); // encoded ID from URL
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCareerById(id))
    }, [dispatch, id])

    const {
        setError,
        register,
        handleSubmit,
        formState: { errors },

    } = useForm();


    const [showSuccessModal, setShowSucsessModal] = useState(false)

    const navigate = useNavigate()

    const handleClick = async (data) => {

        const DataToSend = new FormData();
        DataToSend.append("name", data?.name);
        DataToSend.append("resume", data?.resume[0]);
        DataToSend.append("career_id", id);

        const res = await dispatch(addResume(DataToSend));

        if (res.meta?.requestStatus === "fulfilled") {
            setShowSucsessModal(true)
            setTimeout(() => {
                navigate("/")
            }, 3000);
        } else if (res.meta?.requestStatus === "rejected") {
        }

    }

    const career = useSelector((state) => state.career.getCareerById)

    const data = [
        {
            label: "Pay",
            descn: `₹ ${career?.start_annual_package} - ₹ ${career?.end_annual_package} per annum`,
            img: "/assets/images/career_inner/money.png"
        },
        {
            label: "Job type",
            descn: `${career?.JobType?.name}`,
            img: "/assets/images/career_inner/job_type.png"
        },
        {
            label: "Shift",
            descn: `${career?.Shift?.name}`,
            img: "/assets/images/career_inner/clock.png"
        },
        {
            label: "Number of Vacancy",
            descn: `${career?.vacancy}`,
            img: "/assets/images/career_inner/vacancy.png"
        },
        {
            label: "Experience required:",
            descn: `${career?.experience_from} - ${career?.experience_to} years`,
            img: "/assets/images/career_inner/experience.png"
        },
        {
            label: "Skills",
            descn: `${career?.skill}`,
            img: "/assets/images/career_inner/skills.png"
        },
        {
            label: "Job Location:",
            descn: `${career?.job_location}`,
            img: "/assets/images/career_inner/location.png"
        },

        {
            label: "Application Deadline Date :",
            descn: `${formatDate(career?.deadline)}`,
            img: "/assets/images/career_inner/calnedar.png"
        },
        {
            label: "Languages:",
            descn: `${career?.Career_languages?.map((lang) => (lang?.Language?.name))}`,
            img: "/assets/images/career_inner/language.png"
        },
        {
            label: "Qualification:",
            descn: `${career?.Career_Qualifications?.map((qual) => (qual?.Qualification?.name))}`,
            img: "/assets/images/career_inner/certificate.png"
        },

    ]


    if (!career?.description) {
        return <div></div>;
    }
    return (

        career ?


            <section className='Career_Inner'>
                <div className='container'>
                    <div className='white_box'>
                        <div className='gray_career_card_div'>
                            < Career_Card image={career?.image} id={career?.id} index={0} label={career?.name} descn={parse(career?.description)} />
                        </div>
                        <div className='job_descn_div'>
                            <p className='section_title'>
                                Job details:
                            </p>

                            <div className='details_div'>
                                <div className='row'>
                                    {data?.map((item) => {
                                        return (
                                            <div className='col-md-6'>
                                                <div className='specification_div'>
                                                    <div className='icon_div'>
                                                        <img src={process.env.PUBLIC_URL + item?.img} className='icon_img' />
                                                    </div>
                                                    <div className='data_div'>
                                                        <p className='title_text'>{item?.label}</p>
                                                        <p className='descn_text'>{item?.descn}</p>
                                                    </div>
                                                </div>
                                            </div>

                                        )
                                    })}
                                </div>
                            </div>

                            <div className='roles_div'>
                                <div className='section_title'><img src='/assets/images/career_inner/role.png' className='role_img' /> Roles and responsibilities:</div>

                                <div className='roles_content_div'>
                                    <p className='role_text'><FontAwesomeIcon icon={faCircleCheck} className="check_icon" />{parse(career?.role_permission)}</p>
                                    {/* <p className='role_text'><FontAwesomeIcon icon={faCircleCheck} className="check_icon" />Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    <p className='role_text'><FontAwesomeIcon icon={faCircleCheck} className="check_icon" />Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    <p className='role_text'><FontAwesomeIcon icon={faCircleCheck} className="check_icon" />Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    <p className='role_text'><FontAwesomeIcon icon={faCircleCheck} className="check_icon" />Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> */}
                                </div>
                            </div>

                            <div className='contact_div'>
                                <div className='section_title'>Contact:</div>

                                <p className='black_text'>{career?.hr_name} (HR Manager)</p>
                                <p className='black_text'>{career?.company_name}</p>

                                <div className='recruiter_div'>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <p className='black_text'>Recruiter Contact Number:</p>
                                        </div>
                                        <div className='col-lg-8'>
                                            <p className='light_black_text'>+91 {career?.recruiter_contact_number}</p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <p className='black_text'>Recruiter Email:</p>
                                        </div>
                                        <div className='col-lg-8'>
                                            <p className='light_black_text'>{career?.recruiter_email}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='resume_div'>
                                    <p className='light_black_text'>Upload Resume</p>
                                    <input type='file' className='light_black_text' required
                                        accept=".doc, .docx, .xml, .pdf "
                                        {...register("resume", {
                                            required: "Please Upload Resume!!!",

                                        })} />
                                    <div className='col-lg-4'>
                                        {errors.resume && (
                                            <span className="text-danger">
                                                {errors.resume.message}
                                            </span>
                                        )}
                                    </div>

                                </div>

                            </div>

                            <div className='apply_btn'>
                                <Black_Btn btnText="Apply for job" onClick={handleSubmit(handleClick)} />
                            </div>


                        </div>
                    </div>
                </div>

                <Success_Modal
                    show={showSuccessModal}
                    onHide={() => { setShowSucsessModal(false) }}
                    successText="Application Submitted !"
                />
            </section>
            : <></>
    )
}

export default Career_Inner
